import React, { useState, useEffect } from 'react';
import { Card, CardContent } from './ui/card';
import { FileText, Car, Send, CheckCircle } from 'lucide-react';
import api from '../services/api';

const StatCard = ({ title, value, icon: Icon, color }) => (
  <Card>
    <CardContent className="p-6">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-zinc-500">{title}</p>
          <p className="text-2xl font-bold mt-1">{value}</p>
        </div>
        <div className={`p-3 rounded-full ${color}`}>
          <Icon className="h-5 w-5 text-white" />
        </div>
      </div>
    </CardContent>
  </Card>
);

const Dashboard = () => {
  const [stats, setStats] = useState({ orders: 0, drivers: 0, deliveries: 0, delivered: 0 });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [ordersRes, driversRes, deliveriesRes] = await Promise.all([
          api.get('/orders?limit=1'),
          api.get('/drivers'),
          api.get('/deliveries?limit=1'),
        ]);
        setStats({
          orders: ordersRes.data.total || 0,
          drivers: driversRes.data?.length || 0,
          deliveries: deliveriesRes.data.total || 0,
          delivered: 0,
        });
      } catch (error) {
        console.error('Dashboard stats error:', error);
      }
    };
    fetchStats();
  }, []);

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Хянах самбар</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard title="Нийт захиалга" value={stats.orders} icon={FileText} color="bg-blue-500" />
        <StatCard title="Хүргэлтийн ажилтнууд" value={stats.drivers} icon={Car} color="bg-purple-500" />
        <StatCard title="Хүргэлтүүд" value={stats.deliveries} icon={Send} color="bg-orange-500" />
        <StatCard title="Хүргэгдсэн" value={stats.delivered} icon={CheckCircle} color="bg-green-500" />
      </div>
    </div>
  );
};

export default Dashboard;
